module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "types"
  }, [_c('h2', [_vm._v("Types")]), _vm._v(" "), _c('h3', [_vm._v("Single")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-select', {
    attrs: {
      "name": "default-select",
      "options": _vm.options,
      "placeholder": "Select",
      "label": "Field label"
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("Disabled")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-select', {
    attrs: {
      "name": "default-select",
      "options": _vm.options,
      "placeholder": "Select",
      "label": "Field label",
      "disabled": true
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("Clearable single")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-select', {
    attrs: {
      "name": "default-select",
      "options": _vm.options,
      "placeholder": "Select",
      "label": "Field label",
      "clearble": ""
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("Multiple")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-select', {
    attrs: {
      "name": "default-select",
      "options": _vm.options,
      "placeholder": "Select",
      "label": "Field label",
      "clearble": ""
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("Auto filtering")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-select', {
    attrs: {
      "name": "default-select",
      "options": _vm.options2,
      "placeholder": "Select",
      "label": "Field label",
      "autoFilter": ""
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Select")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-199bc178","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Select.vue
// module id = 9Fxu
// module chunks = 0